import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * نمط موحَّد لكلّ روابط «اقرأ المزيد / انتقل إلى صفحة» في الموقع:
 * كتابة ناعمة + سهم رقيق — بلا خلفيّة سوداء أو زرّ ممتلئ.
 * الأزرار الفعليّة (أضف للسلّة / إتمام الشراء / إرسال) تبقى كما هي.
 */
export const softCtaClass =
  "group inline-flex min-h-[40px] items-center gap-2 border-b border-foreground/25 pb-1 font-sans text-[10.5px] uppercase tracking-[0.22em] text-foreground/85 transition-colors hover:border-foreground hover:text-foreground";

export function SoftCtaArrow({ className }: { className?: string }) {
  return (
    <ArrowRight
      aria-hidden
      className={cn(
        "h-3.5 w-3.5 transition-transform duration-500 group-hover:translate-x-1 rtl:-scale-x-100",
        className,
      )}
    />
  );
}

/** نسخة للاستخدام فوق الصور/الفيديو (نصّ أبيض). */
export const softCtaOnMediaClass =
  "group inline-flex min-h-[40px] items-center gap-2 border-b border-white/45 pb-1 font-sans text-[10.5px] uppercase tracking-[0.22em] text-white/90 transition-colors hover:border-white hover:text-white";
